import React, { useState, useEffect } from 'react'
//import { useVal } from './Dashbord'
import Lottie from "react-lottie"
import lottimoney from './Animation/lottimoney.json'
import { Bar, Line } from 'react-chartjs-2'
import { useAuth } from './AuthContext'
import "./GraphwithList.css"
import app from './firebase'
export default function GraphwthList() {
  
  const { currentUser } = useAuth()
  //const { AM } = useVal()
  //const { DES } = useVal()
  const [keyArraystate,setkeyArray]=useState([])
  const [object, setObject] = useState({})

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData:lottimoney,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  /*useEffect(() => {
    if (AM) {
      var pnode = document.createElement("P")
      var node = document.createElement("LI")
      var textnode = document.createTextNode(AM)
      var paranode = document.createTextNode(DES)
      node.appendChild(textnode)
      pnode.appendChild(paranode)
      document.getElementById("UL").appendChild(node)
      document.getElementById("UL").appendChild(pnode)
    }

  })*/
  /*useEffect(() => {
    var pri = Object.keys(object).map(id => {
      var dt = new Date().toDateString()
      if (typeof object[id][dt] !== 'undefined') {
        var d = object[id][dt]
        return d
      }
    })
    function inte(pri) {
      if (typeof pri == "undefined") {
        return 0
      }
      else {
        return parseInt(pri)
      }
    }
    var po = pri.filter(inte)
    var summm = po.reduce((a, b) => parseInt(a) + parseInt(b), 0)
    //console.log(summm)
  })*/
  useEffect(() => {
    var g = (currentUser.email).split(".")
    app.child(g[0]).on("value", (snapshot) => {
      if (snapshot.val()) {
        setObject({
          ...snapshot.val()
        })

      }
    })
    
  }, [])
  /*useEffect(()=>{
    var keyArray=[]
  
    Object.keys(object).map(id=>{
      keyArray=[...keyArray,Object.keys(object[id])[0]]
    }) 
    setkeyArray(keyArray)
    console.log("type of",keyArraystate)
  })
  useEffect(()=>{
    var keyArray=[]
  
    Object.keys(object).map(id=>{
      keyArray=[...keyArray,Object.keys(object[id])[0]]
    }) 
    setkeyArray(keyArray)
    console.log("type of",keyArraystate)
  },[object])*/
  return (

    <div id="warper">
      <div id="tdlis">
        <div id="ulCont">
          <ul id="UL">
            {
              Object.keys(object).map(id => {
                var dt = new Date().toDateString()
                if (typeof object[id][dt] !== 'undefined') {
                  var d = object[id][dt]
                  return (<div id="lis"><li>{'\u20B9'}{d}</li>
                                <p>{object[id][new Date().toDateString()+"descrip"]}</p>
                           </div>)
                }
              })
            }
            {
              /*Object.keys(object).map(id=>{
                var keyIndex=0
                console.log(keyIndex)
                var d=object[id][keyArraystate[keyIndex++]]
                return <li>{d}{keyArraystate[keyIndex]}</li>
              })*/
            }
          </ul>
        </div>
      </div>
      <div id='lti'>
      <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    </div>
  )
}
